export default class SlotBlings extends Phaser.Group {
  constructor(game, x, y) {
    super(game);

    this.x = x;
    this.y = y;

    this.blingRight = this.game.make.image(50, 0, 'ui_various', 'blings');
    this.blingRight.anchor.set(0, 0.5);
    this.addChild(this.blingRight);

    this.blingLeft = this.game.make.image(-50, 0, 'ui_various', 'blings');
    this.blingLeft.anchor.set(0, 0.5);
    this.addChild(this.blingLeft);

    //
    const time = 800;
    this.animate(time);
    this.game.time.events.add(time, this.animate, this, time);
    this.game.time.events.add(time * 2, this.destroy, this);
  }

  animate(time) {
    this.blingRight.scale.set(0.5);
    this.blingRight.alpha = 0;
    this.blingLeft.scale.set(-0.5, 0.5);
    this.blingLeft.alpha = 0;

    this.game.add.tween(this.blingRight).to({ x: 100 }, time, null, true);
    this.game.add.tween(this.blingRight).to({ alpha: 1 }, 100, null, true);
    this.game.add.tween(this.blingRight).to({ alpha: 0 }, 100, null, true, time - 100);
    this.game.add.tween(this.blingRight.scale).to({ x: 1.5, y: 1.5 }, time, null, true);

    this.game.add.tween(this.blingLeft).to({ x: -100 }, time, null, true);
    this.game.add.tween(this.blingLeft).to({ alpha: 1 }, 100, null, true);
    this.game.add.tween(this.blingLeft).to({ alpha: 0 }, 100, null, true, time - 100);
    this.game.add.tween(this.blingLeft.scale).to({ x: -1.5, y: 1.5 }, time, null, true);
  }

  destroy() {
    this.blingLeft.destroy();
    this.blingRight.destroy();

    this.blingLeft = null;
    this.blingRight = null;

    super.destroy();
  }
}
